import { useState } from "react";
import { toast } from "sonner";
import { Loader2, SearchCheck, Unlock } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

const btn = "inline-flex items-center gap-1.5 h-9 px-3 rounded-xl text-sm font-semibold border disabled:opacity-50";

export function PayoutReconcile({ p, onDone }) {
  const [busy, setBusy] = useState("");
  const [res, setRes] = useState(p.reconcile_result === "nao_encontrado" ? { found: false } : null);
  const [reason, setReason] = useState("");
  const check = async () => {
    setBusy("check");
    try { const { data } = await api.post(`/admin/payouts/${p.id}/reconcile`); setRes(data); toast[data.found ? "success" : "info"](data.message); if (data.found) onDone(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    setBusy("");
  };
  const release = async () => {
    setBusy("release");
    try { const { data } = await api.post(`/admin/payouts/${p.id}/release`, { reason }); toast.success(data.message); onDone(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    setBusy("");
  };
  return (
    <div className="mt-3 rounded-xl border border-warning/40 bg-warning/5 p-3 space-y-2 text-sm" data-testid={`payout-reconcile-${p.id}`}>
      <p className="text-warning font-semibold">Resultado do envio desconhecido — não reenvie sem conferir.</p>
      <p className="text-xs text-zinc-300 break-all" data-testid={`payout-reconcile-ref-${p.id}`}>Referência no Asaas: <span className="font-mono">{p.external_reference || "—"}</span>{p.provider_id ? ` · ID ${p.provider_id}` : ""}{p.pending_min != null ? ` · aguardando há ${p.pending_min} min` : ""}</p>
      <p className="text-xs text-zinc-400">Consulta o Asaas pela referência deste repasse. Se a transferência existir, o status é atualizado automaticamente. Nenhum Pix é enviado nesta tela.</p>
      <button onClick={check} disabled={!!busy} data-testid={`payout-reconcile-check-${p.id}`} className={`${btn} border-[#FF4D00]/50 bg-[#FF4D00]/10 text-[#FF8A3D]`}>
        {busy === "check" ? <Loader2 className="h-4 w-4 animate-spin" /> : <SearchCheck className="h-4 w-4" />}Conferir no Asaas</button>
      {res && !res.found && (
        <div className="space-y-2 pt-1" data-testid={`payout-reconcile-notfound-${p.id}`}>
          <p className="text-xs text-zinc-300">Não encontrada no Asaas. Confirme também no painel do Asaas. Se não existir, libere para reenvio informando o motivo:</p>
          <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Ex.: conferido no painel do Asaas, sem transferência" data-testid={`payout-release-reason-${p.id}`} className="bg-[#09090B] border-white/10 rounded-xl" />
          <button onClick={release} disabled={!!busy || reason.trim().length < 5} data-testid={`payout-release-${p.id}`} className={`${btn} border-white/15 text-zinc-200`}>
            {busy === "release" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Unlock className="h-4 w-4" />}Liberar para reenvio</button>
        </div>
      )}
    </div>
  );
}
